module.exports = __webpack_public_path__ + "img/error.aac39dd4.svg";